import React from "react";
import { SectionLabel, Reveal } from "../primitives";
import { Section, H2, BODY } from "../shared";

export default function SpielregelnSection() {
  return (
    <Section testId="kartendeck-section" className="bg-gold py-24 md:py-36">
      <div className="mx-auto max-w-3xl text-center">
        <div className="flex justify-center">
          <SectionLabel color="espresso" testId="kartendeck-label">Das Kartendeck</SectionLabel>
        </div>
        <Reveal>
          <h2 className={`${H2} mb-12 text-4xl md:text-6xl`}>Nach welchen Spielregeln spielst Du gerade?</h2>
        </Reveal>
        <div className="space-y-6">
          <Reveal delay={0.06}>
            <p className={BODY}>
              Wir sind alle mit einem unterschiedlichen Kartendeck auf diese Welt gekommen – geprägt durch unsere Familie, unsere Erfahrungen, unsere Generation, die Möglichkeiten, die wir hatten.
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <p className={BODY}>Aus diesem Deck haben wir Spielregeln abgeleitet:</p>
          </Reveal>
          <Reveal delay={0.12}>
            <p className={BODY}>
              Glaubenssätze darüber, wie Arbeit, Karriere, Erfolg und ein „gutes“ Leben auszusehen haben.
            </p>
          </Reveal>
          <Reveal delay={0.14}>
            <p className={`${BODY} italic text-cognac-2`}>Die fühlen sich an wie Fakten.</p>
          </Reveal>
          <Reveal delay={0.18}>
            <p className="font-heading text-3xl font-700 uppercase tracking-tight text-espresso md:text-5xl" style={{ fontWeight: 700 }}>
              Sind sie aber nicht.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <p className={BODY}>
              Die meisten von uns verbringen Jahre damit, entweder nach diesen Regeln zu spielen und sich dabei selbst zu verlieren. Oder dagegen anzukämpfen und sich aufzureiben an einem System, das sie nicht ändern können.
            </p>
          </Reveal>
          <Reveal delay={0.22}>
            <p className={`${BODY} font-600 text-espresso`} style={{ fontWeight: 600 }}>
              Das Problem: Beides hält Dich im selben Spiel gefangen.
            </p>
          </Reveal>
          <Reveal delay={0.26}>
            <p className="pt-4 font-heading text-2xl font-600 uppercase tracking-tight text-cognac-2 md:text-3xl" style={{ fontWeight: 600 }}>
              Es gibt einen dritten Weg.
            </p>
          </Reveal>
        </div>
      </div>
    </Section>
  );
}
